export default __webpack_public_path__ + "static/media/move_arrow.b7c7af9d.svg";